import React, { useContext } from "react";
import { FcGoogle } from "react-icons/fc";
import Wosenderabout from "../../../../images/LandingPageImage/template_creation_1x.webp";
import "../designcss/Wosenderaboutenable.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import GetStartedNow from "./GetStartedNow";
import FAQ from "./FAQ";
import Personalisedgrowpage from "./Personalisedgrowpage";
import Personalisedautomation from "./Personalisedautomation";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const PersonalisedMessage = () => {
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <>
      <Navbar />
      <div className="about-hero-container">
        <div className="leftsidecontent">
          <span className="businessgrow">
            Personalized Messaging Strengthen
          </span>
          <span className="usingwhatsapp">
            Customer Relationships on WhatsApp
          </span>
          {/* <span className="marketingservice">and Convert Customers</span> */}

          <p className="paracontent">
            In today’s competitive digital world, customers expect more than
            generic promotions. They respond best to messages that feel timely,
            relevant, and personal. Personalized WhatsApp messaging allows
            businesses to connect naturally and meaningfully, turning ordinary
            conversations into lasting customer relationships.
          </p>

          <div className="buttons">
            <Link to="/login" className="text-decoration-none">
            
            <button className="googlebtn">
              <FcGoogle /> Start With Google
            </button>
            </Link>
            <button onClick={openFreeTrialModal} className="demobtn">Book a Demo</button>
          </div>
        </div>

        <div className="rightsideimg">
          <img src={Wosenderabout} alt="" className="homescreen" />
        </div>
      </div>

      <Personalisedgrowpage />
      <Personalisedautomation />
      <FAQ />
      <GetStartedNow />
      <Footer />
    </>
  );
};

export default PersonalisedMessage;
